export enum Theme {
  Default = "default-dsfr",
  LightBlue = "light-blue",
  BordeauxMetropole = "bordeaux-metropole",
  Soliguide = "soliguide",
  MesAidesOrg = "mes-aides-org",
  ArcEnCiel = "arc-en-ciel",
  VilleDeVannes = "ville-de-vannes",
}

export enum ThemeLabel {
  Default = "Thème bleu foncé (DSFR)",
  LightBlue = "Thème bleu clair",
  BordeauxMetropole = "Thème Bordeaux Métropole",
  Soliguide = "Thème Soliguide",
  VilleDeVannes = "Thème Ville de Vannes",
  MesAidesOrg = "mes-aides.org",
  ArcEnCiel = "Thème arc enciel",
}
